import React from "react";
import './loading.css';
import logo from "./../img/src_images_IHMK.png"

const LogoStyle = {
    margin: "0 auto", 
    textAlign: "center", 
    // position: "absolute",
    marginTop: "200px",
    marginBottom: "-280px"
    // left: "calc(1vw + 45%)"
}

const Loading = () => {
    return (
        <>
        <div style={LogoStyle}>
         <img src={logo}  />
        </div>
        <div className="progress"> 
        </div>
        </>
    )
}

export default Loading;
